import { PAGE_REFERRING_WIDGET_ID } from '@/utils/tracking/TrackingProvider'

export function onArrowPress() {
    localStorage.setItem(PAGE_REFERRING_WIDGET_ID, 'arrow-right')
}

export function onCTAPress() {
    localStorage.setItem(PAGE_REFERRING_WIDGET_ID, 'cta')
}
